import React from "react"

const Title = () => {
  return (
    <div data-aos="fade-down" className="col-lg-8 title">
      <h1>BARTOSZ CIĄPAŁA</h1>
      <h2>-Front-end developer</h2>
    </div>
  )
}

export default Title
